import { LinkedinLogo, TwitterLogo, FacebookLogo, Link as LinkIcon } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function PostShare({ title, shareUrl }) {
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("Link copied");
    } catch {
      toast.error("Could not copy link");
    }
  };

  const iconClass =
    "p-3 border border-white/15 hover:border-[var(--accent)] hover:text-[var(--accent)] transition-colors";

  return (
    <div className="mt-14 max-w-[760px] mx-auto px-6 md:px-0" data-testid="post-share">
      <p className="overline mb-5">Share this article</p>
      <div className="flex items-center gap-4">
        <a
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="share-linkedin"
          className={iconClass}
          aria-label="Share on LinkedIn"
        >
          <LinkedinLogo size={18} />
        </a>
        <a
          href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(shareUrl)}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="share-twitter"
          className={iconClass}
          aria-label="Share on X"
        >
          <TwitterLogo size={18} />
        </a>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="share-facebook"
          className={iconClass}
          aria-label="Share on Facebook"
        >
          <FacebookLogo size={18} />
        </a>
        <button
          onClick={copyLink}
          data-testid="share-copy"
          className={iconClass}
          aria-label="Copy link"
        >
          <LinkIcon size={18} />
        </button>
      </div>
    </div>
  );
}
